<template>
	<v-data-table
		:headers="headers"
		:items="dotacoes"
		:hide-default-footer="dotEmenda"
		v-model="dotacoesSelecionadas"
		:no-data-text="noDataMessage"
		single-expand
		:expanded.sync="expanded"
		item-key="id"
		show-expand
		:search="searchText"
		@pagination="p => (itemsPerPage = p.itemsPerPage)"
		:items-per-page="itemsPerPage"
		:page.sync="page"
		:footer-props="{
			itemsPerPageText: 'Itens por página:'
		}"
		@dblclick:row="rowClick"
	>
		<template v-slot:expanded-item="{ headers, item }">
			<td :colspan="headers.length">
				<v-row>
					<v-col md="1"> <b>Nr.:</b> {{ item.numeroDotacao }} </v-col>
					<v-col md="1"> <b>Ano:</b> {{ item.anoOrcamento }} </v-col>
					<v-col md="10">
						<b>Órgão:</b> {{ item.orgaoCodigo }} - {{ item.orgaoDescricao }}
					</v-col>
					<v-col md="6">
						<b>Função:</b> {{ item.funcaoCodigo }} - {{ item.funcaoDescricao }}
					</v-col>
					<v-col md="6">
						<b>Subfunção:</b> {{ item.subfuncaoCodigo }} -
						{{ item.subfuncaoDescricao }}
					</v-col>
					<v-col md="6">
						<b>Programa:</b> {{ item.programaCodigo }} -
						{{ item.programaDescricao }}
					</v-col>
					<v-col md="6">
						<b>Ação:</b> {{ item.acaoCodigo }} - {{ item.acaoDescricao }}
					</v-col>
					<v-col md="12">
						<b>Clas. Economica:</b> {{ item.economicaCodigo }} -
						{{ item.economicaDescricao }}
					</v-col>
					<v-col md="6">
						<b>Fonte:</b> {{ item.fonteCodigo }} - {{ item.fonteDescricao }}
					</v-col>
					<v-col md="6">
						<b>Cód. Aplicação:</b> {{ item.aplicacaoCodigo }} -
						{{ item.aplicacaoDescricao }}
					</v-col>
					<v-col md="3">
						<b>Valor Fixado Inicial:</b> {{ item.valorFixadoInicial$ }}
					</v-col>
					<v-col md="3">
						<b>Valor Suplementado:</b> {{ item.valorSuplementado$ }}
					</v-col>
					<v-col md="3"> <b>Valor Anulado:</b> {{ item.valorAnulado$ }} </v-col>
					<v-col md="3">
						<b>Valor Fixado Final:</b> {{ item.valorFixadoFinal$ }}
					</v-col>

					<v-col md="3">
						<b>Valor Empenhado:</b> {{ item.valorEmpenhado$ }}
					</v-col>
					<v-col md="3">
						<b>Valor Reservado:</b> {{ item.valorReservado$ }}
					</v-col>
					<v-col md="3"> <b>Valor Liquidado:</b> {{ item.valorLiquidado$ }} </v-col>
					<v-col md="3">
						<b>Valor Pago:</b> {{ item.valorPago$ }}
					</v-col>
				</v-row>
			</td>
		</template>
		<!-- <template v-slot:[`item.actions`]="{ item }" v-if="dotEmenda">
			<v-btn
				color="danger"
				small
				@click="removeItem(item)"
				:disabled="readOnly"
			>
				Remover dotação
			</v-btn>
		</template> -->

        <template v-slot:[`item.valorAnulado$`]="props" v-if="dotAnular">			
         <v-edit-dialog
            :return-value.sync="props.item.dotacao.valorAnulado"
          >
			{{ props.item.valorAnulado }}
            <template v-slot:input>
              <v-text-field
                v-model="props.item.valorAnulado"
                label="Informe o valor"
				:rules="[isNumeric]"
                single-line
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>

        <template v-slot:[`item.valorSuplementado$`]="props" v-if="dotSup">			
         <v-edit-dialog
            :return-value.sync="props.item.valorSuplementado"
          >
			{{ props.item.valorSuplementado }}
            <template v-slot:input>
              <v-text-field
                v-model="props.item.valorSuplementado"
                label="Informe o valor"
                single-line
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>

	</v-data-table>
</template>

<script>
export default {
	props: ['value', 'readOnly', 'dotEmenda', 'dotAnular', 'dotSup', 'searchText'],
	data() {
		let dotacoes = [...this.value];
		dotacoes.forEach(d => {
			d.valorFixadoInicial$ = this.setMascara(d.valorFixadoInicial);
			d.valorSuplementado$ = this.setMascara(d.valorSuplementado);
			d.valorAnulado$ = this.setMascara(d.valorAnulado);
			d.valorFixadoFinal$ = this.setMascara(d.valorFixadoFinal);
			d.valorEmpenhado$ = this.setMascara(d.valorEmpenhado);
			d.valorReservado$ = this.setMascara(d.valorReservado);
			d.valorLiquidado$ = this.setMascara(d.valorLiquidado);
			d.valorPago$ = this.setMascara(d.valorPago);
		});

		return {
			dotacoes,
			headers: [
				{ text: 'Nr. Despesa', value: 'numeroDotacao' },
				//{ text: 'Ano', value: 'anoOrcamento' },
				// { text: 'Órgão', value: 'orgaoDescricao' },
				// { text: 'Função', value: 'secretaria' },
				// { text: 'Subfunção', value: 'nomeParlamentar' },
				{ text: 'Programa', value: 'programaCodigo' },
				//{ text: 'Ação', value: 'acaoDescricao' },
				{ text: 'Ação', value: 'acaoCodigo' },
				// { text: 'Clas. Economica', value: 'valorMascara' },
				//{ text: 'Fonte', value: 'fonteDescricao' },
				{ text: 'Fonte', value: 'fonteCodigo' },
				{ text: 'Class. Econômica', value: 'economicaCodigo' },
				// { text: 'Aplicação', value: 'valorMascara' },
				{ text: 'Valor Fixado Inicial', value: 'valorFixadoInicial$' },
				// { text: 'Valor Suplementado', value: 'valorSuplementado$' },
				{ text: 'Valor Anulado', value: 'valorAnulado$' },
				{ text: 'Valor Fixado Final', value: 'valorFixadoFinal$' },
				{ text: '', value: 'data-table-expand' },
				{ text: '', value: 'actions', sortable: false }
			],
			noDataMessage: 'Não existem dotações para exibição.',
			expanded: [],
			itemsPerPage: 5,
			page: 1,
			dotacoesSelecionadas: [],
			isNumeric: v => isNaN(parseFloat(v)) == false || 'Valor deve ser numérico!'
		};
	},
	
	watch: {
		value() {

			let dotacoes = [...this.value];

			dotacoes.forEach(d => {
				d.valorFixadoInicial$ = this.setMascara(d.valorFixadoInicial);
				d.valorSuplementado$ = this.setMascara(d.valorSuplementado);
				d.valorAnulado$ = this.setMascara(d.valorAnulado);
				d.valorFixadoFinal$ = this.setMascara(d.valorFixadoFinal);
				d.valorEmpenhado$ = this.setMascara(d.valorEmpenhado);
				d.valorReservado$ = this.setMascara(d.valorReservado);
				d.valorLiquidado$ = this.setMascara(d.valorLiquidado);
				d.valorPago$ = this.setMascara(d.valorPago);
			});
			this.dotacoes = dotacoes;
		},

		// dotacoesSelecionadas(value) {
		// 	this.$emit('clicar', value);
		// }
	},

	mounted() {
		if (this.dotEmenda) {
			this.itemsPerPage = 1000;
		}
		else {
			this.itemsPerPage = 5;
		}
	},

	methods: {
		setMascara(v) {
			return v.toLocaleString('pt-BR', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
				style: 'currency',
				currency: 'BRL'
			}).replace('-','\u2011');    // para não quebrar linha
		},

		removeItem(item) {
			this.dotacoes = this.dotacoes.filter(d => d !== item);
			this.$emit('atualizar', item);
		},

		rowClick(evento, dados) {
			this.$emit('clicar', dados.item);
		},

	}
};
</script>
